import React, { useContext, useEffect, useState } from 'react';
import { StockLocation, StockLocationInput } from '../../../../../../../types/stock_location';
import { DropdownSearchSelect } from '../../../../../../components/Dropdown';
import { StockLocationContext } from '../../../../../../../context/StockLocationContext';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { useToast } from '../../../../../../../providers/ToastProvider';
import useMutation from '../../../../../../../hooks/useMutation';
import {
  StockLocationMutations,
  UpdateStockLocationResponse,
  UpdateStockLocationVariables,
} from '../../../../../../../graphql/stockLocation.graphql';
import { ToastType } from '../../../../../../components/Toast';
import { ButtonVariant, SaveChangesButton } from '../../../../../../components/Button';

interface StockLocationOrderPaneProps {
  stockLocation: StockLocation;
}

export default function StockLocationOrderPane({ stockLocation }: StockLocationOrderPaneProps) {
  const { showToast } = useToast();

  const { stockLocations, setStockLocations } = useContext(StockLocationContext);

  const [input, setInput] = useState(new StockLocationInput(stockLocation));

  useEffect(() => setInput(new StockLocationInput(stockLocation)), [stockLocation]);

  const [update, { loading }] = useMutation<UpdateStockLocationResponse, UpdateStockLocationVariables>(
    StockLocationMutations.update,
    {
      variables: { stockLocations: [input.forUpdate()] },
      onCompleted: response => {
        const updatedLocation = response.updateStockLocation[0];
        setStockLocations(new Map(stockLocations).set(updatedLocation.id, updatedLocation));
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.stockLocationUpdatedSuccessfullyToast).singular.upper,
        });
      },
    },
  );

  return (
    <div className='grid gap-2'>
      <div className='grid flex-grow grid-cols-4'>
        <div>
          <DropdownSearchSelect
            label={t(TranslationKey.refillLocation).singular.label}
            placeholder={''}
            items={[...stockLocations.values()].map(sl => sl.id)}
            textBuilder={id => stockLocations.get(id)?.name || ''}
            value={input.refillId}
            onSelect={id => setInput(input.withRefillId(id))}
          />
        </div>
      </div>
      <div>
        <SaveChangesButton
          className='w-fit'
          variant={ButtonVariant.primary}
          onClick={() => update()}
          loading={loading}
          disabled={!input.validate() || !input.hasChanges(stockLocation)}
        />
      </div>
    </div>
  );
}
